<template>
  <div class="data-collection">
      <LoadingSpinner v-if="!jsonData" />
      <div v-if="jsonData" class="search">
          <span>Sök: </span>
          <input v-model="pno" type="text" placeholder="ååååmmdd-xxxx" @keyup="filter" >
      </div>
      <json-viewer v-if="jsonData" :value="filtered ? filtered : jsonData" copyable></json-viewer>
  </div>
</template>



<script>
import JsonViewer from 'vue-json-viewer'
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:"DataCollection",
    components: {JsonViewer,LoadingSpinner},
    data() {
        return {
            jsonData: null,
            pno:null,
            filtered:null
        }
    },
    methods: {
        ...mapActions(['getDataCollection']),
        validate(){
            let path = "^[1-2]{1}[0-9]{3}[0-1]{1}[0-9]{1}[0-3]{1}[0-9]{1}[-][0-9]{4}$"
            let regexp = new RegExp(path);
            return regexp.test(this.pno);
        },
        filter(){
            if(this.validate() && this.jsonData){
                let filtered = {}
                Object.keys(this.jsonData).forEach(async (cat)=>{
                    let loop = await this.jsonData[cat].forEach((item,index)=>{
                        let string = JSON.stringify(item);
                        if(string.search(this.pno) !== -1 ){
                            if(!filtered[cat])
                                filtered[cat] = []; 
                            filtered[cat].push(item)
                        }
                    })
                    this.filtered = filtered;
                    
                })
            }else{
                if(this.filtered){
                    this.filtered = null;
                }
            }
        }   
    },
    computed: {
        ...mapGetters(['user','admin'])
    },
    created() {
        this.getDataCollection().then(res=> this.jsonData = res.data_collection)
    },

}
</script>

<style>

</style>